import * as React from 'react';
import * as Modal from 'react-modal';

import {
	Button,
	Tabs, TabOption,
	Icon,
	ExternalServiceIntegrations,
	EMPTY_EXTERNAL_SERVICE_INTEGRATION_REQUEST,
	isDeployEnabledPerRaterTypeNumberOfRaters,
	isDeployEnabledPerRaterTypeValidFields,
} from '../util';

interface Props {
	isOpen: boolean;
	onCancel(): void;
	onDeploy(externalServiceIntegrations?: ExternalServiceIntegrationRequest[]): void;
}

interface State {
	raterType: RaterType;
	externalServiceIntegrations: ExternalServiceIntegrationRequest[];
}

const RATER_TYPE_OPTIONS: TabOption[] = [
	{value: 'SOCOTRA_RATER', label: 'No'},
	{value: 'EXTERNAL_RATER', label: `Yes`, labelIcon: 'chevron-right'},
];

export default class ConfirmLoadAssetsModal extends React.Component<Props, State> {

	public state: State = {
		raterType: 'SOCOTRA_RATER',
		externalServiceIntegrations: [EMPTY_EXTERNAL_SERVICE_INTEGRATION_REQUEST],
	};

	constructor(props: Props, context: any) {
		super(props);
		this.handleChangeRaterType = this.handleChangeRaterType.bind(this);
		this.handleChangeExternalServiceIntegrations = this.handleChangeExternalServiceIntegrations.bind(this);
		this.handleDeployConfirm = this.handleDeployConfirm.bind(this);
	}

	public render() {
		return <Modal
			contentLabel='confirm-load-assets'
			isOpen={this.props.isOpen}
			onRequestClose={this.props.onCancel}
		>
			{this.renderCloseButton()}
			{this.renderContent()}
		</Modal>;
	}

	private renderCloseButton() {
		return <a className='close-button' onClick={this.props.onCancel}>
			<Icon name='close' />
		</a>;
	}

	private renderContent() {
		return <div className='confirm-load-assets-modal-content'>
			<p>Are you sure you want to deploy your configuration?</p>
			{this.renderWorkflowContent()}
			<p className='center navigation'>
				<Button color='link' onClick={this.props.onCancel}>Cancel</Button>
				<Button
					onClick={this.handleDeployConfirm}
					disabled={!this.isEnabled()}
				>
					Deploy
				</Button>
			</p>
		</div>;
	}

	private renderWorkflowContent() {
		return <div>
			{this.renderUseExternalRaterOptions()}
			{this.renderExternalServiceIntegrationsContainer()}
		</div>;
	}

	private renderExternalServiceIntegrationsContainer() {
		if (this.state.raterType === 'EXTERNAL_RATER') {
			return <div className='external-service-integrations-container'>
				{this.renderExternalServiceIntegrations()}
			</div>;
		} else {
			return null;
		}
	}

	private renderUseExternalRaterOptions() {
		return <Tabs
			contentLabel='config-editor-use-external-rater'
			title='Use External Rater:'
			options={RATER_TYPE_OPTIONS}
			onSelect={this.handleChangeRaterType}
			selectedOption={this.state.raterType}
		/>;
	}

	private renderExternalServiceIntegrations() {
		if (this.state.raterType === 'EXTERNAL_RATER') {
			return <ExternalServiceIntegrations
				externalServiceIntegrations={this.state.externalServiceIntegrations}
				onChange={this.handleChangeExternalServiceIntegrations}
			/>;
		} else {
			return null;
		}
	}

	private handleChangeRaterType(raterType: RaterType) {
		this.setState({
			...this.state,
			raterType,
		});
	}

	private handleChangeExternalServiceIntegrations(externalServiceIntegrations: ExternalServiceIntegrationRequest[]) {
		this.setState({
			...this.state,
			externalServiceIntegrations,
		});
	}

	private handleDeployConfirm() {
		if (this.state.raterType === 'EXTERNAL_RATER') {
			this.props.onDeploy(this.state.externalServiceIntegrations);
		} else {
			this.props.onDeploy(null);
		}
	}

	private isEnabled() {
		const {raterType, externalServiceIntegrations} = this.state;
		return isDeployEnabledPerRaterTypeNumberOfRaters(raterType, externalServiceIntegrations)
			&& isDeployEnabledPerRaterTypeValidFields(raterType, externalServiceIntegrations);
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/ConfirmLoadAssetsModal.tsx